@if (headerConfig) {
  <ez-header
    [assetBucketUrl]="landingpageConfig.assetBucketUrl"
    [imageData]="headerConfig"
    [organisationName]="landingpageConfig.organisation.name"
  ></ez-header>
}

<ng-content select="ez-banner"></ng-content>

<div class="page-content">
  <ng-content></ng-content>
</div>

@if (footerConfig && landingpageConfig && landingpageConfig.organisation) {
  <ez-footer
    class="footer-position"
    [assetBucketUrl]="landingpageConfig.assetBucketUrl"
    [imprintUrl]="landingpageConfig.organisation.web.imprintUrl"
    [dataPrivacyUrl]="landingpageConfig.organisation.web.dataProtectionUrl"
    [imageData]="footerConfig"
    [organisationName]="landingpageConfig.organisation.name"
  >
  </ez-footer>
}
